import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { S3UploadService } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { first } from 'rxjs';
import { CustomerDocumentsService, DocumentRelation } from '../../services/customer-documents/customer-documents.service';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';
import { SelectedCustomerService } from '../../services/selected-customer/selected-customer.service';

@Component({
  selector: 'lib-customer-documents-table-list',
  templateUrl: './customer-documents-table-list.component.html',
  styleUrl: './customer-documents-table-list.component.scss'
})
export class CustomerDocumentsTableListComponent extends ListItemRendererComponent<DocumentRelation[]> {
  constructor(
    protected customerDocumentsService: CustomerDocumentsService,
    protected s3Upload: S3UploadService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungModalService: GungModalService,
    protected translationService: TranslateService
  ) {
    super();
  }

  downloadDocument(document: DocumentRelation): any {
    this.customerDocumentsService.downloadDocument(document);
  }

  uploadDocument(event: any) {
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(customer => {
        this.customerDocumentsService.uploadDocument(event, customer.id);
      });
  }

  deleteDocument(document: DocumentRelation) {
    this.gungModalService
      .openConfirmYesNoModal(undefined, this.translationService.instant('REMOVE') + ' ' + document.name + '?', {
        size: 'sm'
      })
      .then(result => {
        if (result) {
          this.customerDocumentsService.deleteDocument(document.id).subscribe();
        }
      });
  }
}
